<template>
    <Dialog
        :value="true"
        :header-text="$t('Deactivate member')"
        persistent
        @close_modal="$emit('close')"
    >
        <v-container class="pa-0">
            <v-row>
                <v-col class="col-12 py-0">
                    <div class="body-2">
                        {{ $t('Member {0} will be deactivated.').format(deactivateMember.name) }}
                    </div>
                    <div class="body-2 mb-5">
                        {{ $t('Please select new member who will replace {0}.').format(deactivateMember.name) }}
                    </div>
                    <dropdown
                        :items="members"
                        :selected="members.filter(x => x.id === selectedMemberId)"
                        name-key="name"
                        value-key="id"
                        show-selected-first
                        :label="$t('Select new member')"
                        @input="$emit('member-change', $event.id)"
                    />
                    <div class="body-2 font-weight-medium mt-4">
                        {{ $t('NB! Deactivation process cannot be reversed') }}
                    </div>
                </v-col>
            </v-row>
        </v-container>
        <template slot="footer">
            <v-spacer/>
            <primary-button :disabled="!selectedMemberId" :loading="loading" @click="$emit('deactivate')">
                {{ $t("Confirm") }}
            </primary-button>
        </template>
    </Dialog>
</template>

<script>
import Dialog from "@/components/Dialog";
import AccountChip from "../../components/AccountChip";
import ComboboxDropdown from "../../components/ComboboxDropdown";
import {computed, onMounted} from "@vue/composition-api";
import UserModule from "@/store/modules/user";
import errorDialog from "@/views/ErrorDialog/errorDialog";

export default {
    name: "DeactivateMemberDialog",
    components: {
        Dialog,
        AccountChip,
        ComboboxDropdown
    },
    props: {
        selectedMemberId: {
            type: Number,
            default: null
        },
        companyId: {
            type: Number,
            required: true
        },
        editPersonId: {
            type: Number,
            required: true
        },
        loading: {
            type: Boolean,
            default: false
        },
        deactivateMember: {
            type: Object,
            required: true
        }
    },
    setup(props) {
        const userModule = UserModule()

        onMounted(async () => {
            try {
                await userModule.loadMembers()
            } catch (e) {
                errorDialog.showError(e)
            }
        })

        const members = computed(() => userModule.getVisiblePeopleByCompany(props.companyId).filter(x => x.id !== props.editPersonId))

        return {
            members
        }
    }
}
</script>
